<template>

<div class="side-preview animated slideInRight faster" v-if="previewPane.show">
	
    <div class="side-preview-head" v-if="preview">

		<button type="button" class="btn btn-close close" @click="close()" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>

        <div class="car-title">
            <div class="title">
                <h2>{{preview.chassis_number}}</h2>
                <p class="m-0">{{preview.brand}} - {{preview.model}} - {{preview.color}}</p>
            </div>
        </div>

	</div>

	<div class="side-preview-content" v-if="preview">
		
		<div class="pill">
			<div class="data pt-2">
				<h6 class="mt-3">Inicio</h6>
				<table class="table table-sm table-labeled-30">
					<tr>
						<td><strong>Fecha</strong></td>
						<td>{{preview.checkOut}}</td>
					</tr>
					<tr>
						<td><strong>Usuario</strong></td>
						<td>{{preview.user.name}}</td>
					</tr>
					<tr>
						<td><strong>Ubicación</strong></td>
						<td>{{preview.checkOutLocation}}</td>
					</tr>
					<tr>
						<td><strong>Firma</strong></td>
						<td v-if="preview.checkOutSignature"><img :src="preview.checkOutSignature" class="img-fluid"></td>
						<td v-else>No se ha podido registrar la firma</td>
					</tr>
					<tr>
						<td><strong>Aclaración</strong></td>
						<td>{{preview.checkOutSignatureClarification}}</td>
					</tr>
				</table>

				<div v-if="preview.checkOutComments">
					<h6 class="mt-3">Comentarios</h6>
					<p>{{preview.checkOutComments}}</p>
				</div>

			</div>
		</div>

		<hr class="mt-4">
		
		<div class="pill">
			<div class="data pt-2">
				<h6 class="mt-3">Cierre</h6>
				<table class="table table-sm table-labeled-30" v-if="preview.checkIn">
					<tr>
						<td><strong>Fecha</strong></td>
						<td>{{preview.checkIn}}</td>
					</tr>
					<tr>
						<td><strong>Usuario</strong></td>
						<td>{{preview.user.name}}</td>
					</tr>
					<tr>
						<td><strong>Ubicación</strong></td>
						<td>{{preview.checkInLocation}}</td>
					</tr>
					<tr>
						<td><strong>Firma</strong></td>
						<td v-if="preview.checkInSignature"><img :src="preview.checkInSignature" class="img-fluid"></td>
						<td v-else>No se ha podido registrar la firma</td>
					</tr>
					<tr>
						<td><strong>Aclaración</strong></td>
						<td>{{preview.checkInSignatureClarification}}</td>
					</tr>
				</table>

				<div v-else class="text-secondary">
					Pendiente
				</div>

				<div v-if="preview.checkInComments">
					<h6 class="mt-3">Comentarios</h6>
					<p>{{preview.checkInComments}}</p>
				</div>
					
				
			</div>
		</div>
	
	</div>

</div>
</template>
	
<script>

import gql from 'graphql-tag'

export default {
	name: 'TransferPreview',
	props:['id'],
	data () {
		return {
            API_URL: process.env.VUE_APP_API_URL,
			previewPane:{
				show: false,
			},
			preview: {},
		}
	},
	methods:{
		open(id){
			this.preview = {}
			this.previewPane = {
				show: false,
			}
			this.load(id)
		},
		load(id){
			this.$apollo.query({
				query: gql`query ($id: ID!) {
					transfer(id: $id) {
						checkOut
						checkOutLocation
						checkOutSignature
						checkOutSignatureClarification
						checkOutComments
						checkIn
						checkInLocation
						checkInSignature
						checkInSignatureClarification
						checkInComments
						user{
							name
						}
						chassis_number
						model
						color
						brand
						statusText
						status
					}
				}`,
				variables: {
					id: id,
				},
			})
			.then((data) => {
				this.preview = data.data.transfer;
				this.previewPane.show = true;
			});
		},
		close(){
			this.previewPane.show = false;
			this.preview = {};
		},
	}
}


</script>

<style scoped lang="scss">
.car-title{
    display:flex;
    align-items: center;
    text-align: left;

    .brand{
        width:64px;
        height: 64px;
        border-radius: 100%;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        background-color:#fff;
        margin-right: 8px;
        border: solid #fff 3px;
    }
}

</style>
